var map = {
	"./actions.svg": "8cf0",
	"./add.svg": "4646",
	"./arrow-next.svg": "7e4b",
	"./arrow-prev.svg": "8529",
	"./arrow-right.svg": "966d",
	"./arrow-up.svg": "5200",
	"./arrow.svg": "3c0a",
	"./attention.svg": "c7b2",
	"./auto-report.svg": "2bf8",
	"./bill.svg": "8778",
	"./bonus-icon.svg": "e382",
	"./calendar-search.svg": "5566",
	"./calendar.svg": "557c",
	"./cancel.svg": "8f8d",
	"./card.svg": "c64f",
	"./cards.svg": "f863",
	"./clock.svg": "4ccf",
	"./club.svg": "e4e5",
	"./confirm.svg": "a98b",
	"./control-2.svg": "1b9e",
	"./control.svg": "14e6",
	"./dashboard.svg": "5451",
	"./del.svg": "418c",
	"./delivery.svg": "f7e7",
	"./discount.svg": "38d6",
	"./download.svg": "24a4",
	"./edit.svg": "8399",
	"./error.svg": "2804",
	"./faq.svg": "73fe",
	"./feedback.svg": "01e4",
	"./generated-report.svg": "01ef",
	"./hamburger.svg": "22b4",
	"./info.svg": "0c83",
	"./list.svg": "dcef",
	"./lock.svg": "27fa",
	"./login.svg": "00ae",
	"./logout.svg": "24fc",
	"./loyality.svg": "e8ed",
	"./mail.svg": "90e4",
	"./network.svg": "a307",
	"./new.svg": "9429",
	"./news.svg": "ac1d",
	"./offline.svg": "bb6a",
	"./operation.svg": "291d",
	"./operations.svg": "90e8",
	"./participants.svg": "658f",
	"./password.svg": "7b0a",
	"./percent.svg": "7db8",
	"./phone.svg": "9855",
	"./placeholder-image.svg": "5cd9",
	"./placeholder-logo.svg": "7232",
	"./placeholder.svg": "421e",
	"./plus.svg": "8c7a",
	"./point.svg": "47ff",
	"./polls.svg": "0660",
	"./products.svg": "f632",
	"./push.svg": "d357",
	"./reload.svg": "3e11",
	"./remove.svg": "fa38",
	"./report.svg": "2237",
	"./retail.svg": "c688",
	"./rrn.svg": "ff97",
	"./save.svg": "99e2",
	"./search.svg": "0930",
	"./server_error.svg": "dc38",
	"./settings.svg": "cbdc",
	"./smile.svg": "f3a0",
	"./star-icon.svg": "050b",
	"./success.svg": "17bf",
	"./table.svg": "f538",
	"./template.svg": "812c",
	"./terminal.svg": "7b74",
	"./trash.svg": "dab5",
	"./unvisibility.svg": "6999",
	"./upload.svg": "1ed6",
	"./user-avatar.svg": "5cee",
	"./user-red.svg": "731d",
	"./user.svg": "7393",
	"./visibility.svg": "2d14",
	"./webshop.svg": "e3d2",
	"./work-space.svg": "1128",
	"./workflow.svg": "fc9c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";